export default __webpack_public_path__ + "static/media/shortlistempty.aea57ea2.svg";